<template>
    <v-app id="inspire">
        <MyMenu :title="title" :url="menuUrl"></MyMenu>

        <v-content>

            <v-container fluid>
                <v-card tile flat
                        color="primary lighten-4 ">
                    <v-card-subtitle class="primary lighten-4 py-1">
                        <v-row no-gutters>
                            <span>検索条件</span>
                        </v-row>
                    </v-card-subtitle>
                    <v-container fluid>
                        <v-row no-gutters>
                            <v-col cols="3" class="pa-2">
                                <template v-if="LoginPermission == '1' ">
                                    <v-text-field label="店舗コード" disabled v-model="searchCondition.store_code"></v-text-field>
                                </template>
                                <template v-if="LoginPermission != '1' ">
                                    <MyInputStoreCode v-model="searchCondition.store_code"
                                                      :login_info="login_info"></MyInputStoreCode>
                                </template>
                            </v-col>
                            <v-col cols="3" class="pa-2">
                                <MyInputWholesaleCode v-model="searchCondition.wholesale_code"></MyInputWholesaleCode>
                            </v-col>
                            <v-col cols="2" class="pa-2">
                                <MyDatePicker label="納品日(From)" v-model="searchCondition.fr_slip_date"></MyDatePicker>
                            </v-col>

                            <v-col cols="2" class="pa-2">
                                <MyDatePicker label="納品日(To)" v-model="searchCondition.to_slip_date"></MyDatePicker>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col v-if="LoginPermission == '2' || LoginPermission == '4'" cols="3" class="pa-2">
                                <MyInputCompanyCode v-model="searchCondition.company_code"
                                                    class="upper-input-field">
                                </MyInputCompanyCode>
                            </v-col>
                            <v-col cols="3" class="pa-2">
                                <v-text-field dense label="GS1コード" v-model="searchCondition.gs1_code"></v-text-field>
                            </v-col>
                            <v-col cols="3" class="pa-2">
                                <v-text-field dense label="JANコード" v-model="searchCondition.jan_code"></v-text-field>
                            </v-col>
                            <v-col cols="2" class="pa-2">
                                <v-text-field dense label="伝票番号" v-model="searchCondition.van_slip_no"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="3" class="pa-2">
                                <v-text-field dense label="商品名(ｶﾅ)" v-model="searchCondition.product_name_half"></v-text-field>
                            </v-col>
                            <v-col cols="3" class="pa-2">
                                <v-text-field dense label="規格名(ｶﾅ)" v-model="searchCondition.standard_capacity_half"></v-text-field>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="3">
                                <v-btn class="mx-2" color="primary darken-3" dark v-on:click="onSearch" :loading="searchCondition.is_loading">
                                    <font-awesome-icon icon="search" size="1x" />
                                </v-btn>

                                <template v-if="LoginPermission == '2' || LoginPermission == '4' ">
                                    <v-tooltip top>
                                        <template v-slot:activator="{on}">
                                            <v-btn class="mx-2" color="primary darken-3" dark v-on="on" @click="onExportCSV">
                                                <v-icon>mdi-file-export-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>CSV 出力(一覧より出力)</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <template v-slot:activator="{on}">
                                            <v-btn class="mx-2" color="primary darken-3" dark v-on="on" @click="onExportCSVSeach">
                                                <v-icon>mdi-file-export-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>CSV 出力(再検索して出力)</span>
                                    </v-tooltip>
                                </template>
                                <template v-else>
                                    <v-tooltip top>
                                        <template v-slot:activator="{on}">
                                            <v-btn class="mx-2" color="primary darken-3" dark v-on="on" @click="onExportCSV">
                                                <v-icon>mdi-file-export-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>CSV 出力</span>
                                    </v-tooltip>
                                </template>
                                <v-btn class="mx-2" color="primary darken-3" dark v-on:click="onClearCondition">クリア</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                    <v-container fluid
                                 class="white"
                                 pt-0 mt-0 pb-0 mb-0
                                 v-if="old_code_hit">
                        <v-row>
                            <v-col class="pa-1" cols="auto">
                                <v-chip :class=old_code_hit_color small></v-chip>
                                <span style="font-size:12px">：旧GS1コード(旧販売包装単位コード)または旧JANコードで発注</span>
                            </v-col>
                        </v-row>
                    </v-container>
                    <MyDataTable :fixed-header="true"
                                 dense class="grey lighten-4"
                                 :headers="headers"
                                 :items="items"
                                 no-data-text="対象データがみつかりませんでした"
                                 :sort-by.sync="sortBy"
                                 :sort-desc.sync="sortDesc">
                        <template v-slot:item="{ item }">
                            <tr :class="item.itemClass">
                                <td v-for="header in headers" :key="header.value">
                                    <div :style="{ textAlign: isSelected(header.value, rightAlignColumns) ? 'right' : 'left' }">
                                        {{ isSelected(header.value, commaAddColumns) ? addComma(item[header.value]) : item[header.value] }}
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </MyDataTable>
                </v-card>

            </v-container>

        </v-content>

        <MyLoading v-bind:is_loading="searchCondition.is_loading">
        </MyLoading>
    </v-app>
</template>

<script>
    import moment from "moment";

    export default {
        props: {
            title: { type: String, required: true },
            menuUrl: { type: String, required: true },
            isAdmin: { type: Boolean, default: false },
            apiBase: { type: String, required: true } 
        },
        mounted: function () {
            this.$nextTick(function () {
                // ビュー全体がレンダリングされた後にのみ実行されるコード
                if (this.LoginPermission == "1") {
                    this.searchCondition.store_code = this.LoginCode;
                }
                if (this.LoginPermission == '3') {
                    this.searchCondition.company_code = this.LoginCode;
                }
            })
        },
        data: () => ({           
            LoginCode: g_login_code,
            LoginPermission: g_permission,
            login_info: {
                company_code: g_login_code,
                permission: g_permission,
            },
            searchCondition: {
                company_code: "",
                store_code: "",
                wholesale_code: "",
                fr_slip_date: "",
                to_slip_date: "",
                gs1_code: "",
                jan_code: "",
                product_name_half: "",
                standard_capacity_half:"",
                van_slip_no: "",
                apply_date: "",
                is_searched: false,
                is_loading: false,
            },
            baseHeaders: [
                { text: '企業コード', value: 'company_code', filterable: false, width: 80 },
                { text: '企業名', value: 'company_name', filterable: false, width: 350 },
                { text: '店舗コード', value: 'store_code', filterable: false, width: 130 },
                { text: '店舗名', value: 'store_name', filterable: false, width: 350 },
                { text: 'GS1コード', value: 'gs1_code', filterable: false, width: 130 },
                { text: 'JANコード', value: 'jan_code', filterable: false, width: 130 },
                { text: '商品名(ｶﾅ)', value: 'product_name_half', filterable: false, width: 300 },
                { text: '規格名(ｶﾅ)', value: 'standard_capacity_half', filterable: false, width: 300 },
                { text: '数量', value: 'quantity', filterable: false, width: 100, align: 'end' },
                { text: '納品日', value: 'slip_date', filterable: false, width: 90 },
                { text: '卸名', value: 'wholesale_name', filterable: false, width: 250 },
                { text: '伝票番号', value: 'van_slip_no', filterable: false, width: 100 },
                { text: '行番号', value: 'van_slip_row_no', filterable: false, width: 90, align: 'end' },
                { text: '送信先コード', value: 'send_to_code', filterable: false, width: 130 },
                { text: '副送信先コード', value: 'sub_send_to_code', filterable: false, width: 140 },
                { text: '送信元(卸)コード', value: 'send_from_first_code', filterable: false, width: 150 },
                { text: 'VAN伝票区分', value: 'slip_class_h', filterable: false, width: 130 },
                { text: '商品コード区分', value: 'product_code_class_h', filterable: false, width: 140 },
                { text: '単価', value: 'price', filterable: false, width: 100, align: 'end' },
                { text: '金額', value: 'amount', filterable: false, width: 100, align: 'end' },
                { text: '薬価', value: 'drug_price', filterable: false, width: 100, align: 'end' },
                { text: '有効期限', value: 'expiration_date', filterable: false, width: 100 },
                { text: '製造番号', value: 'serial_no', filterable: false, width: 100 },
                { text: '税額区分基準日', value: 'tax_class_date', filterable: false, width: 150 },
                { text: '税額対象品目区分', value: 'tax_product_class_h', filterable: false, width: 200 },
                { text: 'VAN連携フラグ', value: 'van_link_flg_h', filterable: false, width: 150 },
                { text: 'VAN連携日', value: 'van_link_date_h', filterable: false, width: 200 },
            ],

            items: [],
            sortBy: [null],
            sortDesc: [null],
            old_code_hit: false,
            old_code_hit_color: "red lighten-4",
            rightAlignColumns: ['quantity', 'van_slip_row_no', 'price', 'amount', 'drug_price', 'ds_price', 'ds_amount'],
            commaAddColumns: ['price', 'amount', 'drug_price', 'ds_price', 'ds_amount'],
        }),
        computed: {
            headers() {
                const headers = [...this.baseHeaders];             
                const index = headers.findIndex(h => h.value === 'drug_price');
                // 管理者画面用の項目追加
                if (index !==-1 && this.isAdmin) {
                    const extraHeaders = [
                        { text: '伝票単価', value: 'ds_price', filterable: false, width: 100, align: 'end' },
                        { text: '伝票金額', value: 'ds_amount', filterable: false, width: 100, align: 'end' }
                    ];
                    headers.splice(index + 1, 0, ...extraHeaders);
                }
                return headers;
            }
        },
        methods: {
            async onSearch() {
                try {
                    var today = new Date();
                    var yyyy = String(today.getFullYear());
                    var mm = String((today.getMonth() + 1));
                    var dd = String(today.getDate());
                    mm = ("00" + mm).slice(-2);
                    dd = ("00" + dd).slice(-2);
                    var sysDate = (yyyy + mm + dd);
                    this.searchCondition.apply_date = sysDate;

                    this.items = [];

                    console.log('onsearch');
                    var params = new URLSearchParams();
                    params.append('param', JSON.stringify(this.searchCondition));

                    this.searchCondition.is_loading = true;
                    let res = await this.axios_post(`${this.apiBase}/Search`, params);
                    console.log(res.data);
                    if (res.data.status !== "OK") {
                        this.msg_error_dialog(res.data.messages);
                        return;
                    }

                    this.old_code_hit = false;
                    res.data.items.forEach(function (item) {
                        if (item.old_jan_hit) {
                            item.itemClass = this.old_code_hit_color;
                            this.old_code_hit = true;
                        } else {
                            item.itemClass = "";
                        }
                    }, this)

                    this.items = res.data.items;

                } catch (err) {
                    this.msg_error_dialog(err);
                } finally {
                    this.searchCondition.is_loading = false;
                }

            },
            onExportCSV() {

                if (this.items.length == 0) {

                    this.msg_error_dialog("対象の明細がありません。検索を行って下さい。");
                    return;
                }

                var tmpName = "納品履歴一覧__";
                if (this.isAdmin) {
                    tmpName = "納品履歴一覧(管理者)__";
                }
                var csvName = tmpName + moment().format('YYYYMMDDHHmmss') + ".csv";


                this.CreateCSV(csvName, this.headers, this.items, this.sortBy, this.sortDesc);

            },
            async onExportCSVSeach() {
                try {
                    var today = new Date();
                    var yyyy = String(today.getFullYear());
                    var mm = String((today.getMonth() + 1));
                    var dd = String(today.getDate());
                    mm = ("00" + mm).slice(-2);
                    dd = ("00" + dd).slice(-2);
                    var sysDate = (yyyy + mm + dd);
                    this.searchCondition.apply_date = sysDate;

                    console.log('onsearch');
                    var params = new URLSearchParams();
                    params.append('param', JSON.stringify(this.searchCondition));

                    this.searchCondition.is_loading = true;
                    let res = await this.axios_post(`${this.apiBase}/ExportCSVSeach`, params);
                    console.log(res.data);
                    if (res.data.status !== "OK") {
                        this.msg_error_dialog(res.data.messages);
                        return;
                    }

                    this.downloadBase64CSV(res.data.csvName, res.data.base64);
                } catch (err) {
                    this.msg_error_dialog(err);
                } finally {
                    this.searchCondition.is_loading = false;
                }
            },
            onClearCondition() {
                let v = new Date().toISOString().substr(0, 10);
                if (this.LoginPermission != "1") {
                    this.searchCondition.store_code = "";
                }
                if (this.LoginPermission != "3") {
                    this.searchCondition.company_code = "";
                }
                this.searchCondition.wholesale_code = "";
                this.searchCondition.fr_slip_date = `${v.substr(0, 4)}${v.substr(5, 2)}${v.substr(8, 2)}`
                this.searchCondition.to_slip_date = `${v.substr(0, 4)}${v.substr(5, 2)}${v.substr(8, 2)}`;
                this.searchCondition.gs1_code = "";
                this.searchCondition.jan_code = "";
                this.searchCondition.product_name_half = "";
                this.searchCondition.standard_capacity_half = "";
                this.searchCondition.van_slip_no = "";
                this.searchCondition.is_searched = false;
                this.searchCondition.is_loading = false;
                this.items = [];
                this.old_code_hit = false;
            },

        }

    }
</script>
<style>
    .v-messages__message {
        line-height: 18px !important;
        font-size: 18px;
    }

    tbody tr:nth-of-type(odd) {
        background-color: rgba(0, 0, 0, .05);
    }

    .v-toolbar__extension {
        display: none;
    }

    input:-webkit-autofill {
        animation-name: onAutoFillStart;
        transition: background-color 50000s ease-in-out 0s;
    }

    .upper-input-field .v-text-field {
        padding: 0 !important;
    }

    .upper-input-field .v-text-field > * {
        padding: 0 !important;
    }

    .upper-input-field .v-input__control > * {
        padding: 0 !important;
    }
</style>